// eslint-disable-next-line import/prefer-default-export
export enum CFDatabaseFoundation {
  AFP_5 = "AFP 5",
  AFP_6_3 = "AFP 6.3",
  GFLI = "GFLI 2.0",
  GFLI_2_2 = "GFLI 2.2",
  GFLI_3_0 = "GFLI 3.0",
  AFP_7_0_FLAG = "AFP7.0 FLAG",
}
